import { mapGetters, mapActions } from "vuex";
import setBlobImageSize from "@/plugins/setBlobImageSize";
import snap from "@/components/mixins/snap";
import domtoimage from "@/plugins/dom-to-image";

export default {
  mixins: [
    snap
  ],
  data() {
    return {
      tid: null,
      coverParam: "", // 对应项目接口的thumbnailUrl
      screenParam: "", // 对应项目接口的screen
      // saveState: "notSaved", // notSaved | saving | saved
      saved: false,
      isLock: false,
      draftId: "", //项目Id,保存项目时和projectId一起返回的
      saveDraftTime: "",
      currentDraft: null,
      privateDraft: null,
      manualSave: '',
      isMultiLogin: false,
      loginError: void 0,
    };
  },
  computed: {
    ...mapGetters([
      "MaterialPane_Size",
      "TopNav_Size",
      "TOOL",
      "Tool_Size",
      "WorksName",
      "WorksProjectId",
      "isPreventDefault",
      "SelectSprites_Msg",
      "UserEquity",
      "UserLevel",
      "TmpLevelType",
      "UserMsg",
      "IsVipSprites",
      "WatermarkInfo",
      "StyleArrayMsg",
      "cooperationType",
      "UserTeamInfo",
      "showCooperationBtn",
      "cooperationDraftOwnerId",
      'cooperationDraftId',
      'WorksTemplateId',
      'WorksTemplateIds'
    ]),
    ...mapGetters({
      storedUserId: "getUserId",
      subtitles: 'subtitle/subtitles',
      openSubtitle: "subtitle/openSubtitle",
      subtitleObj: 'subtitle/subtitleObj'
    })
  },
  methods: {
    track() {
      let sourceList = [
        '使用模板进入（web端）',
        '模板广场-新建空白点击（web端）',
        '模板广场-导入PPT点击（web端）',
        '工作台-新建空白（web端）',
        '工作台-导入PPT（web端）',
        '工作台-我的作品（web）',
        '工作台-我的项目(web)',
        '工作台-与我协作(web)',
      ];
      sensors.track('saveDraft', {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: '',
        content_duration: this.TOOL.getDuration() / 1000,
        draft_id: this.WorksId,
        drafts_number: this.TOOL.sprites.length,
        is_teamwork: this.IsPrivateDraft ? false : true,
        price_type: '',
        price: '',
        // publish_time: '',
        purpose: '',
        source: '',
        teamwork_id: this.IsPrivateDraft ? '非团队' : this.cooperationDraftId,
        template_id: this.WorksTemplateId || '',
        title: this.WorksName,
        video_duration: this.TOOL.getDuration() / 1000,
      });
    },
    async getSnapByDom(dom, { sec } = {}) {
      let $video = $(dom).find("video");
      if ($video[0]) {
        let flag = await this.beforeGetSnap({
          palyerScene: dom,
          sec,
          scene: this.TOOL.selectedScenes,
          isPlayerLayer: false
        });
      }

      return new Promise(resolve => {
        domtoimage
          .toBlob2(dom, {
            bgcolor: "transparent",
            _width: dom.offsetWidth,
            _height: dom.offsetHeight,
            width: 640,
            height: (640 * dom.offsetHeight) / dom.offsetWidth,
            quality: 0.5,
            style: {
              overflow: "hidden"
            },
            filter: node => {
              // let isMask = node && node.classList && node.classList.contains('mask-blur');
              return node.tagName !== "VIDEO";
            }
          })
          .then(blob => {
            if (this.TOOL.optimized !== "Horizontal") {
              let height = (640 * dom.offsetHeight) / dom.offsetWidth;
              let width = (height * 9) / 16;
              setBlobImageSize({
                blob,
                height,
                width,
                sx: (640 - width) / 2,
                sy: 0,
                sw: width,
                sh: height
              }).then(blob => {
                resolve(blob);
              });

              return;
            }

            resolve(blob);
          })
          .catch(err => {
            console.warn(err);
            resolve(new Blob());
          })
          .finally(() => {
            console.log(`Turbo ~ .finally ~ 'kkk'`, 'kkk')
            this.TOOL.sprites.forEach(scene => {
              scene.sprites.forEach(sprite => {
                if (sprite.type === 'Video') {
                  const ele = document.getElementById('sprite-' + sprite.id);
                  ele.style.backgroundImage = ''
                  const playerEle = document.getElementById('player-sprite-' + sprite.id);
                  console.log(`Turbo ~ .finally ~ ele.style.backgroundImage`, ele.style.backgroundImage)
                  playerEle.style.backgroundImage = ''
                  console.log(`Turbo ~ .finally ~ playerEle.style.backgroundImage`, playerEle.style.backgroundImage)
                }
              })
            });
          })
      });
    },
    uploadThumbnail() {
      let contentEl = this.TOOL.getSelectScenes
        ? this.TOOL.selectedScenes.element.content[0]
        : this.TOOL.contentBody[0];
      let scenes = this.TOOL.sprites;
      let jqPlayer = this.TOOL.player.ele;
      let dur = this.TOOL.sprites[0].getDuration();
      let point = dur > 1000 ? dur - 1000 : 1000;
      if (point < 0) {
        point = 0;
      }

      this.cacheScene = this.TOOL.getSelectScenes();

      return new Promise((resolve, reject) => {
        this.getSnapByDom(contentEl).then(blob => {
          let formData = new FormData();
          formData.append("files[]", blob);
          formData.append("isScreen", 1);
          formData.append('isAnimEdit', 1);
          this.$http({
            url: "/api/upload/file",
            method: "post",
            data: formData
          })
            .then(res => {
              let { code, data } = res.data;
              // data.filename
              if (!data) {
                data = {};
              }
              blob = null;
              resolve(data.filename || "");
            })
            .catch(err => {
              reject(err);
            });
        });
      });
    },
    uploadCoverSnaps() {
      let { snaps } = this;
      let tasks = [];

      snaps.forEach((cover, i) => {
        if (!cover.blob) {
          return;
        }
        let formData = new FormData();
        formData.append("draft_thumbnail", cover.blob);

        let p = this.$http({
          url: "/api/upload/file",
          method: "post",
          data: formData
        });

        p = p
          .then(res => {
            let { code, data, msg } = res.data;
            if (code >= 300) {
              // Promise.reject('msg');
              return;
            }
            // this.snapArr[i] = {filename: data.filename, active: i === 0};
            this.snapArr[i] = data.filename;
            cover = null;
            return res;
          })
          .catch(err => { });

        tasks.push(p);
      });
      this.snaps = [];
      return tasks;
    },
    getSnaps() {
      this.$store.commit("save_TopnavMsg", {
        isShowSavingMask: true,
        savingMaskText: ""
      });
      // let myResolve;
      // let myReject;
      const vm = this;
      let scenes = this.TOOL.sprites;
      let cacheScene = this.TOOL.getSelectScenes();
      let pointObj = vm.getMiddlePoint();
      let startDom; //= this.TOOL.contentBody[0]
      let jqPlayer = this.TOOL.player.ele;
      let myTasks = [];
      myTasks[0] = () => {
        // let myResolve;
        // let t = () => {
        //   // 截取第一场倒数第一秒
        //   let dur = vm.TOOL.sprites[0].getDuration();
        //   let point = dur > 1000 ? dur - 1000 : dur;
        //   eve('playByFrame', null, parse(point), this.TOOL.sprites[0].id);
        //   this.getSnapByDom2(jqPlayer.find('#player-scene-' + scenes[0].id)[0])
        //     .then(() => {
        //       myResolve();
        //     })
        // }
        // return new Promise((resolve) => {
        //   myResolve = resolve;
        //   t()
        // })
      };
      myTasks[1] = () => {
        return new Promise(resolve => {
          let dur = vm.TOOL.sprites[0].getDuration();
          // 截取第一场第一秒
          let point = dur > 1000 ? 1000 : 500;

          // 截取第一场中间一帧
          // let point = dur / 2;

          // eve('playByFrame', null, parse(point), vm.TOOL.sprites[0].id);
          this.TOOL.eve.emit("play_" + vm.TOOL.sprites[0].id, parse(point));
          vm.getSnapByDom2(jqPlayer.find("#player-scene-" + scenes[0].id)[0], {
            scene: scenes[0]
          }).then(() => {
            resolve();
          });
        });
      };
      myTasks[2] = () => {
        return new Promise(resolve => {
          eve(
            "playByFrame",
            null,
            parse(pointObj.diffTime),
            vm.TOOL.sprites[pointObj.index].id
          );
          this.TOOL.eve.emit(
            "play_" + vm.TOOL.sprites[pointObj.index].id,
            parse(pointObj.diffTime)
          );
          vm.getSnapByDom2(
            jqPlayer.find("#player-scene-" + scenes[pointObj.index].id)[0],
            {
              scene: scenes[pointObj.index]
            }
          ).then(() => {
            resolve();
          });
        });
      };
      myTasks[3] = () => {
        return new Promise((resolve, reject) => {
          let point =
            scenes[scenes.length - 1].duration > 1000
              ? scenes[scenes.length - 1].duration - 1000
              : scenes[scenes.length - 1].duration;
          // eve('playByFrame', null, parse(point), scenes[scenes.length - 1].id);
          this.TOOL.eve.emit(
            "play_" + scenes[scenes.length - 1].id,
            parse(point)
          );
          this.getSnapByDom2(
            jqPlayer.find("#player-scene-" + scenes[scenes.length - 1].id)[0],
            {
              scene: scenes[scenes.length - 1]
            }
          ).then(() => {
            onOpsEnd();
            resolve();
          });
        });
      };

      let process = () => {
        // myTasks[0]()
        return Promise.resolve()
          .then(myTasks[1])
          .then(myTasks[2])
          .then(myTasks[3])
          .then(() => {
            // myResolve();
            this.$store.commit("save_TopnavMsg", {
              isShowSavingMask: false
            });
          })
          .catch(err => {
            this.$store.commit("save_TopnavMsg", {
              isShowSavingMask: false
            });
            // myReject(err);
            console.warn(err);
            onOpsEnd();
          });
      };

      // 显示content层的素材，不在时间范围内的则不显示
      function showSprites(scene) {
        let { duration, nowTime } = scene;
        nowTime *= 1000;
        scene.sprites.forEach(sprite => {
          sprite.effect._syncContent(parse(nowTime));
        });

        // scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate)
      }

      // video sprite and video bg
      function syncVideoCurrentTime() {
        vm.TOOL.sprites.forEach(scene => {
          scene.updateBgVideo(scene.nowTime * scene.editor.option.frameRate);
          (scene.sprites.filter(s => s.type === "Video") || []).map(v => {
            v.updateCurrentTimeBySec(scene.nowTime);
          });
        });
      }

      function onOpsEnd() {
        // vm.TOOL.selectScenes(cacheScene || vm.TOOL.sprites[0]);

        // 隐藏player层
        vm.TOOL.cancelPlay();
        cacheScene.show();
        showSprites(cacheScene || vm.TOOL.sprites[0]);
        syncVideoCurrentTime();
      }

      function parse(n) {
        return (n / 1000) * 60;
      }

      // this.TOOL.selectScenes(scenes[0]) // content层不跳动
      let processing = process();

      return processing;
    },
    /**
     * 指定时间截图
     *
     */
    async getSnapByDom2(dom, { sec, scene } = {}) {
      let jqPlayer = this.TOOL.player.ele;
      jqPlayer.show();
      dom.style.display = "";
      let extraShowEl = [];

      let $video = $(dom).find("video");
      if ($video[0]) {
        let flag = await this.beforeGetSnap({ palyerScene: dom, sec, scene });
      }

      return new Promise(resolve => {
        domtoimage
          .toBlob2(dom, {
            bgcolor: "transparent",
            _width: dom.offsetWidth,
            _height: dom.offsetHeight,
            width: 640,
            height: (640 * dom.offsetHeight) / dom.offsetWidth,
            quality: 0.5,
            style: {
              overflow: "hidden"
            },
            filter: node => {
              try {
                if ($(node).css("display") === "none") {
                  return false;
                }
              } catch (e) { }

              let isPass = true;

              let notVideo = node.tagName !== "VIDEO";
              isPass = notVideo;
              let isImg = node.tagName === "IMG";
              let isHandWriteSvg =
                node.classList &&
                node.classList.contains("_my-hand-player-svg");
              if (isHandWriteSvg) {
                $(node)
                  .parent()
                  .css("display") !== "none" &&
                  extraShowEl.push(
                    $(node)
                      .next()
                      .show()
                  );
              }
              let hasSpecial =
                node.classList &&
                (node.classList.contains("frame-image") || isHandWriteSvg);
              if (hasSpecial) {
                isPass = false;
              }
              if (isImg) {
                isPass = node.src && node.src.length > 0;
              }

              return isPass;
            }
          })
          .then(blob => {
            if (extraShowEl.length) {
              extraShowEl.forEach(el => {
                el.hide();
              });
            }

            if (this.TOOL.optimized !== "Horizontal") {
              let height = (640 * dom.offsetHeight) / dom.offsetWidth;
              let width = (height * 9) / 16;
              setBlobImageSize({
                blob,
                height,
                width,
                sx: (640 - width) / 2,
                sy: 0,
                sw: width,
                sh: height
              }).then(blob => {
                this.snaps.push({
                  blob
                  // url: this.getBlobUrl(blob)
                });
                dom.style.display = "none";
                jqPlayer.hide();
                resolve();
              });

              return;
            }

            this.snaps.push({
              blob
              // url: this.getBlobUrl(blob)
            });
            dom.style.display = "none";
            jqPlayer.hide();
            resolve();
          })
          .catch(err => {
            console.warn(err);
            dom.style.display = "none";
            jqPlayer.hide();
            resolve();
          })
          .finally(() => {
            this.TOOL.sprites.forEach(scene => {
              scene.sprites.forEach(sprite => {
                if (sprite.type === 'Video') {
                  const ele = document.getElementById('sprite-' + sprite.id);
                  ele.style.backgroundImage = ''
                  const playerEle = document.getElementById('player-sprite-' + sprite.id);
                  playerEle.style.backgroundImage = ''
                }
              })
            });
          })
      });
    },
    getBlobUrl(blob) {
      return window.URL.createObjectURL(blob || new Blob());
    },

    /**
     * 判断编辑器内容是否空，空则不保存为项目
     *
     * @returns {Boolean}
     */
    isEmptyEditor() {
      let json = this.TOOL.toJson();
      let hasSprite = false;
      let hasBg = false;
      let hasSceneSound = false;
      let hasSceneEffect = false;
      let checkSound = (obj = {}) => {
        if (obj.sound && obj.sound.resourceId) {
          return true;
        }
        if (
          Array.isArray(obj.sound) &&
          obj.sound.some(sound => sound && sound.resourceId)
        ) {
          return true;
        }
      };
      json.scenes.some(scene => {
        if (scene.sprites.length) {
          hasSprite = true;
          return true;
        }
        if (
          scene.background.resourceId ||
          scene.background.url ||
          (scene.background.color &&
            scene.background.color.toLowerCase() !== "#ffffff")
        ) {
          hasBg = true;
          return true;
        }
        if (checkSound(scene)) {
          hasSceneSound = true;
          return true;
        }
        if (
          scene.enterEffect.type !== "None" ||
          scene.exitEffect.type !== "None"
        ) {
          hasSceneEffect = true;
          return true;
        }
      });
      let hasGlobalSound = false;
      if (checkSound(json)) {
        hasSceneSound = true;
      }

      let ret =
        !hasSprite &&
        !hasBg &&
        !hasSceneSound &&
        !hasSceneEffect &&
        !hasGlobalSound;
      return ret;
    },

    saveWorks({ hard = false, onCompleted = () => { } } = {}) {
      if (hard) {
        this.$store.commit('set_WorksSaveState', "notSaved");
      }
      // if (this.saveState === "saved") {
      //   this.saveState = "saving";
      //   setTimeout(() => {
      //     this.saveState = "saved";
      //     this.saveDraftTime = this.getTimeString();
      //   }, 1000);
      //   // 手动保存，项目无变化;
      //   this.$bus.emit("saveWorks.completed");
      //   return;
      // }
      if (this.isLock) {
        this.$bus.emit("saveWorks.completed");
        return Promise.resolve();
      }
      this.isLock = true;
      this.unlockDelay();
      this.$store.commit('set_WorksSaveState', "saving");

      return this.saveDraftAfterThumb({ onCompleted });
    },
    saveDraftAfterThumb({ onCompleted }) {
      this.uploadThumbnail()
        .then(val => {
          this.screenParam = val;
          this.$http.post('/api/user/draft/updateThumbnail', {
            screen: val,
            draftId: this.IsPrivateDraft ? (this.WorksId || this.WorksProjectId) : this.cooperationDraftId,
          });
          // return this.saveWorks_({
          //   coverUrls: this.coverParam
          // });
        })
        .catch(err => {
          console.warn(err);
          this.$store.commit('set_WorksSaveState', "notSaved");
          // this.saveWorks_({
          //   coverUrls: this.coverParam
          // })
        });
      return this.saveWorks_({ onCompleted });
    },
    // sendReviewer(auditor) {
    //   this.$http
    //     .post("/api/user/account/cooperationVideo/toReviewDraft", {
    //       id: this.currentDraft.id,
    //       auditor: auditor
    //     }).then(() => {
    //       window.onbeforeunload = null;
    //       window.location.replace(window.origin + "/workbench/creation/draft");
    //     });
    // },
    //保存项目
    saveWorks_({
      coverUrls = "",
      screenParam = "",
      isFirstFrameCover = false,
      commitReview = false,
      templateId = '',
      onCompleted,
      auditor = ""
    } = {}) {
      if (!this.manualSave && this.isPassDraft === 6 && !commitReview) {
        onCompleted && onCompleted();
        this.$bus.emit("saveWorks.completed");
        return Promise.resolve();
      }
      if (this.manualSave) {
        // sensors.track('saveDraft', {
        //   draft_id: this.WorksId,
        //   drafts_number: this.TOOL.sprites.length,
        //   video_duration: this.TOOL.getDuration() / 1000,
        //   source: '',
        //   title: this.WorksName,
        //   is_teamwork: this.IsPrivateDraft ? false : true,
        //   teamwork_id: this.cooperationDraftId,
        // });
        this.track();
      }
      const vm = this;
      if (this.TOOL.sprites.length === 1) {
        this.TOOL.sprites[0].fromJsonLoadingState = 2;
      }
      let data = this.TOOL.toJson();
      data.subtitle = this.subtitleObj;
      if (isFirstFrameCover) {
        data.cover = screenParam;
      } else {
        delete data.cover;
      }
      let worksJson = data;
      data = JSON.stringify(data);

      let caption = null;
      if (this.subtitleObj) {
        caption = JSON.stringify(this.subtitleObj);
      }
      //let caption = JSON.stringify(this.subtitleObj);
      // if (this.myWorksName) {
      //   this.$store.commit('save_WorksName', this.myWorksName)
      // }
      let worksList = this.$store.getters['smartVoice/worksList'];
      let dubbings = this.$store.getters['addSoundtrack/getDubbingArr'];
      worksList = worksList.filter((v, i, arr) => {
        // return dubbings.some(u => u.url === v.url);
        return arr.findIndex(u => u.url === v.url) == i;
      });
      let otherInfos = { audios: worksList };
      otherInfos = JSON.stringify(otherInfos);
      let queryParams = {
        title: this.WorksName,
        // thumbnailUrl: coverUrls,
        data,
        otherInfos,
        caption,
        times: this.TOOL.getDuration() / 1000,
        screen: screenParam || this.screenParam,
        direction: this.TOOL.getOptimizedNum() || 1,
        isPass: commitReview ? 4 : '',
        auditor
      };
      if (!screenParam) {
        delete queryParams.screen;
      }

      if (this.WorksProjectId) {
        queryParams = {
          ...queryParams,
          projectId: this.WorksProjectId
        };
      }

      if ("templateid" in vm._data) {
        queryParams.templateId = vm._data.templateid;
      }
      if (templateId) {
        this.$store.commit('save_TemplateId', templateId);
        queryParams.templateId = templateId;
      }
      let templateIds = [templateId, vm._data.templateid, ...this.WorksTemplateIds].filter(v => v) || [];
      const uniqInput = templateIds;
      templateIds = [];
      uniqInput.forEach(v => {
        const hasItem = templateIds.includes(v);
        if (!hasItem) {
          templateIds.push(v);
        }
      });
      if (templateIds.length) {
        queryParams.templateId = templateIds.join(',');
      }
      if ("storyboard" in this.$route) {
        let worksJson = this.$util.localStorage.get("storyBoardData") || {};
        let ids = (worksJson.scenes || []).map(item => item.sceneId);
        queryParams.story = ids.join(",");
      }

      //保存后的逻辑判断
      let afterSave = res => {
        let { data, code, msg } = res.data;
        if (code === 412) {
          this.$memberGuide({
            show: true,
            context: this,
            funcRight: {
              type: "draftNumber",
              name: "草稿数量",
            },
          });
          this.isLock = false;
          return;
        }
        if (code === 413) {
          this.showExportedMsg();
          return;
        }
        if (code !== 200) {
          let isMulti = res.data.code === 4001;
          if (isMulti) {
            this.isMultiLogin = isMulti;
          }
          const draftInfo = res.data.data;
          const isLogin = draftInfo && draftInfo.id;
          if (isMulti && !isLogin && this.UserMsg && this.UserMsg.id != null) {
            let temp = `<div style="color: ##606266;">监测到您的账号在其他设备上登录,当前账号已自动退出。系统已自动为您保存项目,重新登录后可在“工作台-我的创作”中查看。</div>
            <div style="color: ##606266;">若账号存在账号和密码泄露的风险,还请至“个人中心-账号设置”中修改密码。</div>`;

            this.$alert(temp, '退出登录提示', {
              dangerouslyUseHTMLString: true,
              callback: (action) => {
                window.onbeforeunload = null;
                window.location.assign('/templates?login=true');
              }
            });
            throw new Error(msg);
          }
          else {
            this.$message({
              // message: 7012 === code ? msg : "保存失败，请稍后重试",
              message: msg || "保存失败，请稍后重试",
              type: "error",
              duration: 1200
            });
            this.isLock = false;
          }
        }
        // 分个人项目id和协作id不能乱改
        // this.draftId = data.id;
        // location.replace(`#/${this.draftId}`);
        if (!data) {
          return;
        }
        let { projectId } = data;
        vm.$store.commit("save_WorksProjectId", projectId);
        vm.$store.commit("save_WorksId", this.draftId);
        this.worksJson = worksJson;

        this.$store.commit('set_WorksSaveState', "saved");
        this.isLock = false;
        onCompleted && onCompleted();
        this.$bus.emit("saveWorks.completed");
        this.saveDraftTime = this.getTimeString();
        this.$store.commit('set_SaveDraftTime', this.saveDraftTime);

        //空项目
        if (!this.currentDraft) {
          this.$http
            .get("/api/user/account/cooperation/teamInfo")
            .then(({ data: info }) => {
              if (info.data && info.data.state === 0) {
                this.$http
                  .get(
                    "/api/user/account/cooperation?sOfPage=99999&fPage=99999"
                  )
                  .then(({ data: coodata }) => {
                    if (coodata.data && coodata.data.length) {
                      const element = coodata.data.find(
                        x => x.cooperatorId === this.UserMsg.id
                      );
                      if (element) {
                        this.$store.commit("setCooperationType", element.type);
                        return;
                      }
                    }
                    this.$store.commit("setCooperationType", -1);
                  });
              } else this.$store.commit("setCooperationType", -1);
            });
        }
      };

      if (this.loginError) {
        throw new Error(this.loginError);
      }
      //1、团队项目 保存
      if (
        this.privateDraft != true &&
        this.currentDraft &&
        this.currentDraft.cooperationType >= 0 &&
        this.currentDraft.shareDraft
      ) {
        this.currentDraft.data = queryParams.data;
        this.currentDraft.otherInfos = queryParams.otherInfos;
        this.currentDraft.caption = queryParams.caption;
        this.currentDraft.title = queryParams.title;
        this.currentDraft.duration = queryParams.times;
        this.currentDraft.times = queryParams.times;
        this.currentDraft.thumbnailUrl = queryParams.screen;
        this.$store.commit("setCooperationDraft", this.currentDraft);

        return this.$http
          .post("/api/user/account/cooperation/templateU", {
            id: this.currentDraft.id,
            data: this.currentDraft.data,
            otherInfos: this.currentDraft.otherInfos,
            title: this.currentDraft.title,
            duration: this.currentDraft.duration,
            thumbnailUrl: this.currentDraft.thumbnailUrl,
            screen: this.currentDraft.thumbnailUrl,
            caption: this.currentDraft.caption,
            updateTime: Date.now(),
            isPass: queryParams.isPass,
            auditor
          })
          .then(res => {
            this.saveWorksValue =res;
            // //console.log("保存协同项目", res);
            if (res.data.code === 200) {
              let updateTime = res.data.data;
              res.data.data = {
                id: this.currentDraft.id,
                projectId: this.currentDraft.id,
                updateTime
              };
              // //console.log('保存协同项目', this.currentDraft)
            }
            afterSave(res);
          })
          .catch(err => {
            this.saveWorksValue =err;
            console.warn(err);
            this.checkMultiLogin();
            this.$message({
              message: err.message || "保存失败",
              type: "error",
              duration: 1200
            });
            this.$store.commit('set_WorksSaveState', "notSaved");
            this.isLock = false;
            this.$bus.emit("saveWorks.completed");
          });
      }
      // 即将下架
      let toRemoveList = this.$store.getters['ToRemoveList'] || [];
      let removeMaterial = toRemoveList.map(v => {
        return v.resourceId;
      });
      removeMaterial = removeMaterial.join(',');
      queryParams.removeMaterial = removeMaterial;
      
      queryParams.draftId = window.location.hash.slice(2) || this.$route.projectId;
      //2、个人项目 保存
      this.$store.commit('set_WorksSaveState', "saving");
      return this.$http
        .post("/api/user/draft", queryParams)
        .then(res => {
          this.saveWorksValue =res;
          this.IsVipSprites.data;
          //console.log('个人项目 保存',res);
          if (!this.draftId && res.data.data) {
            this.draftId = res.data.data.id;
          }
          if (this.draftId)
            location.replace(`#/${ this.draftId }`);
          return afterSave(res);
        })
        .catch(err => {
          this.saveWorksValue =res;
          console.warn(err);
          this.checkMultiLogin();
          this.$message({
            message: err.message || "保存失败",
            type: "error",
            duration: 1200
          });
          this.$store.commit('set_WorksSaveState', "notSaved");
          this.isLock = false;
          this.$bus.emit("saveWorks.completed");
        })
        .finally(() => {
          this.manualSave = '';
        });
    },
    /**
     * 检查多处登录被挤出
     */
    checkMultiLogin() {
      const vm = this;
      return this.$http.get("/api/session").then(res => {
        let { data, code } = res.data;
        let isMulti = code === 4001;
        if (isMulti) {
          this.isMultiLogin = isMulti;
        }
        const isLogin = data && data.id;
        let isLogout = !isLogin;
        let dialogName = this.openSubtitle ? 'SubtitleMessageDialog' : 'MessageDialog';

        if (data && data.id && data.id !== vm.storedUserId) {
          this.$modal.show(dialogName, {
            title: "登录状态异常。",
            content:
              "由于您登录了另一个账号，请刷新页面。",
            btns: [{ type: "Ok", content: "刷新页面", className: "button-Ok" }],
            resultHandler: type => {
              window.onbeforeunload = null;
              // window.location.reload();
              window.location.replace('/templates');
            }
          });

          return 'error: 由于您登录了另一个账号，请刷新页面。';
        }
        if (isMulti && !isLogin && this.UserMsg && this.UserMsg.id != null) {
          // this.$modal.show("MessageDialog", {
          //   title: "退出登录提示",
          //   content:
          //     "您的账号所登录的设备已超出数量限制，当前账号已自动退出登录。我们已保存您的当前项目，重新登录后可在“作品管理-我的项目”中查看。若存在账号和密码泄露的风险，还请至“个人中心-账号设置”中修改密码。",
          //   btns: ["Close"],
          //   resultHandler: type => {
          //     window.location.assign('/templates?login=true');
          //   }
          // });

          let temp = `<div style="color: ##606266;">监测到您的账号在其他设备上登录,当前账号已自动退出。系统已自动为您保存项目,重新登录后可在“工作台-我的创作”中查看。</div>
          <div style="color: ##606266;">若账号存在账号和密码泄露的风险,还请至“个人中心-账号设置”中修改密码。</div>`;

          this.$alert(temp, '退出登录提示', {
            dangerouslyUseHTMLString: true,
            callback: (action) => {
              window.onbeforeunload = null;
              window.location.assign('/templates?login=true');
            }
          });

          return 'error: 在其他设备上登录';
        }
        if (isLogout && !this.isMultiLogin) {
          this.$modal.show(dialogName, {
            title: "当前您处于未登录状态。",
            content:
              "由于在未登录情况下编辑的项目不能被保存，还请重新登录后再进行编辑。",
            btns: [{ type: "custom", content: "重新登录" }],
            resultHandler: type => {
              window.onbeforeunload = null;
              window.location.assign('/templates?login=true');
            }
          });
          return 'error: 未登录';
        }
      });
    },
    getTimeString() {
      let date = new Date();
      let minutes = date.getMinutes();
      return date.getHours() + ":" + (minutes < 10 ? "0" + minutes : minutes);
    },
    unlockDelay() {
      clearTimeout(this.timerUnlock);
      this.timerUnlock = setTimeout(() => {
        this.isLock = false;
      }, 8000);
    },
    showExportedMsg() {
      this.$modal.show("MessageDialog", {
        title: "提示",
        content:
          "该草稿已导出为作品。如需继续修改，请在作品封面处点击“复制并编辑”即可继续编辑。",
        btns: [{ type: "Ok", content: "查看作品列表", className: "button-Ok" }],
        resultHandler: (type) => {
          if (type == "Ok") {
            window.onbeforeunload = null;
            window.location.replace('/workplace/dashboard/creator/all/works');
          }
        },
      });
    }
  }
};




// WEBPACK FOOTER //
// ./src/components/mixins/draft.js